import * as React from 'react';
import {RouteComponentProps} from "react-router";
import {PluginTemplates} from "../../../../utils/PluginTemplates";
import FalconHeader from "../../../../components/navigation/FalconHeader";
import FalconFooter from "../../../../components/navigation/FalconFooter";
import {authorize, Overlay} from "@athena-portal/components";
import {ICacheManager, ICustomerPortalService, Types, NEW_PAYMENT, PaymentCard} from "@falcon/services";
import {lazyInject} from "@athena-portal/core";
import {Redirect} from "react-router-dom";
import {setSessionStorage} from "../../../../CommonFunctions";

interface IStartPaymentPageParams {
    policyNumber: string
}

interface IProps extends RouteComponentProps<IStartPaymentPageParams> {
}

interface IState {
    party: PaymentCard | null,
}

@authorize
export class StartPaymentPage extends React.Component<IProps, IState> {

    @lazyInject(Types.CustomerPortalService)
    private customerPortalService: ICustomerPortalService;

    @lazyInject(Types.CacheManager)
    private cacheManager: ICacheManager;

    private pluginTemplates = new PluginTemplates();

    constructor(props: IProps) {
        super(props);
        this.state = {
            party: null
        };
    }

    public componentDidMount(): void {
        this.pluginTemplates.setPageTitle("Start payment");
        this.cacheManager.clearCache("getAnnualPolicyInfo");
        this.customerPortalService.getMainPaymentCard(this.props.match.params.policyNumber).subscribe((output: PaymentCard) => {
            this.setState({
                party: output
            })
        });
        setSessionStorage("paymentSettings", this.props.location.state);
        setSessionStorage("referrerJourney", NEW_PAYMENT);
    }

    public render() {
        if (this.state.party) {
            if (this.state.party.reuseCard) {
                return <Redirect to={{pathname: `/dashboard/account/existingCardPayment/${this.props.match.params.policyNumber}`}}
                />
            } else {
                return <Redirect to={{pathname: `/dashboard/account/newCardPayment/${this.props.match.params.policyNumber}`}}
                />
            }
        }
        return (
            <React.Fragment>
                <FalconHeader/>
                    <Overlay show={true}/>
                <FalconFooter/>
            </React.Fragment>
        )
    }
}



// WEBPACK FOOTER //
// ./src/pages/dashboard/common/payments/StartPaymentPage.tsx